import React, { useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
export const RatingLabel = ({
  labelVariant,
  children
}) => {
  const positiveLabelClassname = useMemo(() => clsx(styles.positiveLabel, styles.coloredLabel), []);
  const negativeLabelClassname = useMemo(() => clsx(styles.negativeLabel, styles.coloredLabel), []);

  if (labelVariant === 'positive') {
    return /*#__PURE__*/React.createElement("span", {
      className: positiveLabelClassname
    }, children || 'Рекомендую');
  }

  if (labelVariant === 'negative') {
    return /*#__PURE__*/React.createElement("span", {
      className: negativeLabelClassname
    }, children || 'Не рекомендую');
  }

  return /*#__PURE__*/React.createElement("span", {
    className: styles.primaryLabel
  }, children);
};